import React, { useState } from 'react';
import { SparklesIcon } from 'lucide-react';
export function PokemonCard({
  pokemon,
  onClick,
  isPokemonShiny,
  onToggleShiny
}) {
  const [isHovering, setIsHovering] = useState(false);
  const getTypeColor = type => {
    const typeColors = {
      Normal: 'bg-gray-400',
      Fire: 'bg-red-500',
      Water: 'bg-blue-500',
      Electric: 'bg-yellow-400',
      Grass: 'bg-green-500',
      Ice: 'bg-blue-200',
      Fighting: 'bg-red-700',
      Poison: 'bg-purple-500',
      Ground: 'bg-yellow-600',
      Flying: 'bg-indigo-300',
      Psychic: 'bg-pink-500',
      Bug: 'bg-lime-500',
      Rock: 'bg-yellow-800',
      Ghost: 'bg-purple-700',
      Dragon: 'bg-indigo-700',
      Dark: 'bg-gray-700',
      Steel: 'bg-gray-500',
      Fairy: 'bg-pink-300'
    };
    return typeColors[type] || 'bg-gray-400';
  };
  const isShiny = isPokemonShiny(pokemon.id);
  const imageUrl = isShiny && pokemon.shinyImage ? pokemon.shinyImage : pokemon.image;
  // Handle click on the card, but not on the shiny toggle button
  const handleCardClick = e => {
    if (e.target.closest('.shiny-toggle')) {
      return; // Don't propagate if clicking the shiny toggle
    }
    onClick();
  };
  // Handle shiny toggle click
  const handleToggleShiny = e => {
    e.stopPropagation(); // Prevent card click
    onToggleShiny(pokemon.id);
  };
  return <div className="bg-slate-700/60 rounded-lg overflow-hidden border border-slate-600 shadow-md hover:shadow-lg transform hover:scale-105 transition-all cursor-pointer relative" onClick={handleCardClick} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)} data-id="element-205">
      <div className="p-4 pb-2" data-id="element-206">
        <div className="flex justify-between items-start" data-id="element-207">
          <h3 className="text-lg font-semibold text-white" data-id="element-208">{pokemon.name}</h3>
          <span className="text-sm text-gray-400" data-id="element-209">
            #{pokemon.id.toString().padStart(3, '0')}
          </span>
        </div>
        <div className="flex gap-2 mt-1" data-id="element-210">
          {pokemon.types.map(type => <span key={type} className={`${getTypeColor(type)} px-2 py-1 rounded-full text-xs font-medium text-white`} data-id="element-211">
              {type}
            </span>)}
        </div>
      </div>
      <div className="relative pt-2 pb-4 px-4 flex justify-center" data-id="element-212">
        <img src={imageUrl} alt={pokemon.name} className="h-32 w-32 object-contain z-10" data-id="element-213" />
        
        {/* Shiny toggle button - visible on hover or when active */}
        <button className={`shiny-toggle absolute top-2 right-2 p-1.5 rounded-full transition-opacity ${isShiny ? 'bg-yellow-500 opacity-100' : 'bg-slate-600 opacity-0'} ${isHovering ? 'opacity-80' : ''} hover:opacity-100 z-20`} onClick={handleToggleShiny} title={isShiny ? 'Show normal form' : 'Show shiny form'} data-id="element-214">
          <SparklesIcon className={`h-4 w-4 ${isShiny ? 'text-white' : 'text-yellow-300'}`} data-id="element-215" />
        </button>
      </div>
      <div className="grid grid-cols-3 gap-1 text-center text-xs text-gray-300 bg-slate-800 px-2 py-2" data-id="element-216">
        <div data-id="element-217">
          <p className="font-semibold" data-id="element-218">HP</p>
          <p data-id="element-219">{pokemon.stats.hp}</p>
        </div>
        <div data-id="element-220">
          <p className="font-semibold" data-id="element-221">ATK</p>
          <p data-id="element-222">{pokemon.stats.attack}</p>
        </div>
        <div data-id="element-223">
          <p className="font-semibold" data-id="element-224">DEF</p>
          <p data-id="element-225">{pokemon.stats.defense}</p>
        </div>
      </div>
    </div>;
}